require('../css/main.scss');
require('../css/cookies.scss');

const mobileMenu = require('./func/mobile-menu');

window.addEventListener('DOMContentLoaded', run);

async function run(e) {
    mobileMenu('.c-mobile-menu', '.c-mobile-menu_button');
}
